import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
export function useTermsItem() {
    const { t } = useTranslation();
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const isMobile = useContext(MobileContext);
    return {
        key: 'terms',
        label: t('siteHeader.userMenu.termsOfService'),
        link: Url.buildFromPath(URLS.TOS),
        biData: BiData({
            evid: 702,
            link_url: Url.buildFromPath(URLS.TOS),
            menu_item: 'tos',
            menu_name: 'profile'
        }),
        tabIndex: isUserMenuOpen || !isMobile ? 0 : -1
    };
}
